import {
  BusEvent,
  Dispatcher,
  DispatcherPriority,
  WS_DIRECT_MESSAGE_RECEIVE_DATA
} from '@fnd/timeline'
import AssistantEventBus from './AssistantEventBus'

class AssistantDispatcher extends Dispatcher<
  WS_DIRECT_MESSAGE_RECEIVE_DATA,
  any
> {
  protected consumable: boolean = false

  public criteria(
    event: BusEvent<WS_DIRECT_MESSAGE_RECEIVE_DATA, any>
  ): boolean {
    return true
  }

  public constructor() {
    super(AssistantEventBus)
  }

  protected priority: DispatcherPriority = 'MEDIUM'
}

export default AssistantDispatcher
